import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { withDevtools } from '@pc/store';
import { MedicalDataVm, MedicalQuestionsVm } from '../models/medical-question-vm';
import { computed } from '@angular/core';
import { Traveler } from '../../../shared/models/traveler.interface';

interface HealthDecState {
  isLoading: boolean;
  questions: MedicalDataVm | null;
  questionnaireId: number | null;
  answersHealthScreening: MedicalQuestionsVm | [];
  mainHealthDeclarationQuestions: MedicalQuestionsVm | [];
  medicalAssessmentTravelersData: Record<number, { id: string; label: string }[]>;
  medicalAssessmentData: MedicalQuestionsVm | [];
  validationRequest: Omit<Traveler, 'productCover'>[];
}

export const HealthDecInitialState: HealthDecState = {
  isLoading: false,
  questions: null,
  questionnaireId: null,
  mainHealthDeclarationQuestions: [],
  answersHealthScreening: [],
  medicalAssessmentTravelersData: {},
  medicalAssessmentData: [],
  validationRequest: []
};

export type HealthDecStore = InstanceType<typeof HealthDecStore>;

export const HealthDecStore = signalStore(
  { providedIn: 'root' },
  withDevtools('HealthDecStore'),
  withState(HealthDecInitialState),
  withMethods((store) => ({
    setIsLoading(isLoading: boolean): void {
      patchState(store, { isLoading });
    },
    setMedicalQuestions(questions: MedicalDataVm | undefined): void {
      if (!questions) return;
      patchState(store, {
        ...questions,
        questions
      });
    },
    setHealthScreeningAnswers(answersHealthScreening: MedicalQuestionsVm | []): void {
      patchState(store, {
        answersHealthScreening: [...answersHealthScreening]
      });
    },
    setHealthScreeningValidationRequest(validationRequest: Omit<Traveler, 'productCover'>[]): void {
      patchState(store, {
        validationRequest: [...validationRequest]
      });
    },
    setMedicalAssessmentTravelersData(medicalAssessmentData: Record<number, { id: string; label: string }[]>): void {
      patchState(store, {
        medicalAssessmentTravelersData: { ...medicalAssessmentData }
      });
    },
    setMedicalAssessmentData(medicalAssessmentData: MedicalQuestionsVm | []): void {
      patchState(store, {
        medicalAssessmentData: [...medicalAssessmentData]
      });
    },
    setMainHealthDeclarationQuestions(mainHealthDeclarationQuestions: MedicalQuestionsVm | []): void {
      patchState(store, {
        mainHealthDeclarationQuestions: [...mainHealthDeclarationQuestions]
      });
    },
    resetMedicalAssessmentData(): void {
      patchState(store, {
        medicalAssessmentData: [],
        medicalAssessmentTravelersData: {}
      });
    },
    setQuestionnaireId(questionnaireId: number): void {
      patchState(store, {
        questionnaireId
      });
    }
  })),
  withComputed((store) => ({
    isShowMedicalAssessment: computed(() =>
      store
        .questions()
        ?.getQuestions()
        .some((q) => store.medicalAssessmentTravelersData()[q.getParentId()])
    )
  }))
);
